export default __webpack_public_path__ + "static/media/htbabyImg1.44eb8dfd.png";